import { useEffect, useRef } from 'react';

import { OTHER_REASON_KEY } from '@web/components/subscriptionPreferenceSurvey/constants';

export const useReasonStep = (reason: string, other: string) => {
  const commentInputRef = useRef<HTMLTextAreaElement>(null);

  const isCommentVisible = reason === OTHER_REASON_KEY;
  const isValid = reason && (!isCommentVisible || other);

  useEffect(() => {
    if (isCommentVisible) {
      commentInputRef.current?.focus();
    }
  }, [isCommentVisible]);

  return {
    commentInputRef,
    isCommentVisible,
    isValid,
  };
};
